import { httpRequest } from "@/utils/HttpRequest";
import { IPage } from "@/types/AppTypes";
import {
    IPurchaseRoSearch,
    IPurchaseRoDetail,
    IPurchaseRoFields,
    Detailed,
    IPurchaseRoList,
    IPurchaseRoSettleAndWhConfirm,
    IPurchaseDetailsSearch,
    IPurchaseDetails,
    IPurchaseRoStatistics
} from "./purchaseRoType"

class PurchaseRoService {
    async page(searchVo: IPurchaseRoSearch) {
        const apiUrl = "/vrm2/preturn/findPage";
        return await httpRequest.post<IPurchaseRoList>(apiUrl, searchVo);
    }
    async total(searchVo: IPurchaseRoSearch) {
        const apiUrl = "/vrm2/preturn/total";
        return await httpRequest.post<IPurchaseRoStatistics>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/vrm2/preturn/findById/${id}`;
        return await httpRequest.get<IPurchaseRoDetail>(apiUrl);
    }

    async insert(insertVo: IPurchaseRoFields) {
        const apiUrl = "/vrm2/preturn/insert";
        return await httpRequest.post<IPurchaseRoDetail>(apiUrl, insertVo);
    }
    async update(updateVo: IPurchaseRoFields) {
        const apiUrl = "/vrm2/preturn/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    //明细删除
    async materialDelete(params: Detailed) {
        const apiUrl = "/vrm2/preturn/materialDelete";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //导出
    async export(params: IPurchaseRoFields) {
        const apiUrl = "/vrm2/preturn/export";
        return await httpRequest.postFile(apiUrl, params, { timeout: 300000 });
    }
    //作废
    async invalidate(params: IPurchaseRoSettleAndWhConfirm) {
        const apiUrl = "/vrm2/preturn/invalidate";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //退货结算
    async settle(params: IPurchaseRoSettleAndWhConfirm) {
        const apiUrl = "/vrm2/preturn/settlePro";
        // const apiUrl = "/vrm2/preturn/settle";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //采购退货查询详情
    async details(params: IPurchaseDetailsSearch) {
        const apiUrl = "/vrm2/purchase/details/findPage";
        return await httpRequest.post<IPage<IPurchaseDetails>>(apiUrl, params);
    }
    // //详情导入
    // async import(){
    //     const apiUrl = "/vrm2/preturn/detail/downloadTpl";
    //     return await httpRequest.getFile<boolean>(apiUrl);
    // }
    //下载模板
    //库房确认
    async warehousing(params: IPurchaseRoSettleAndWhConfirm) {
        const apiUrl = "/vrm2/preturn/warehousing";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //详情导出
    async detailsExport(params: IPurchaseRoFields) {
        const apiUrl = "/vrm2/preturn/detailsExport";
        return await httpRequest.postFile(apiUrl, params, { timeout: 300000 });
    }
    //打印次数
    async printNum(id: string) {
        const apiUrl = `/vrm2/preturn/print/${id}`;
        return await httpRequest.get(apiUrl);
    }
}

export const purchaseRoService = new PurchaseRoService();